// ©2024 Austin App House. All rights reserved.
import React, { useRef, useState } from 'react';

const toggleBtnStyle = {
  position: 'absolute',
  right: 8,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 20,
  width: 40,
  height: 40,
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
};

const fieldWrapStyle = {
  position: 'relative',
};

const inputStyle = {
  paddingRight: 48,
  width: '100%',
  boxSizing: 'border-box',
};

const ProfilePasswordField = ({
  id,
  name,
  label,
  value,
  onChange,
  maxLength = 30,
  minLength = 12,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  const toggleVisibility = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const next = !showPassword;
    setShowPassword(next);

    if (inputRef.current) {
      inputRef.current.type = next ? 'text' : 'password';
    }
  };

  return (
    <div className="field_row">
      <div className="field_name">
        <label htmlFor={id}>{label}</label>
      </div>
      <div className="field_block password_field" style={fieldWrapStyle}>
        <input
          ref={inputRef}
          type={showPassword ? 'text' : 'password'}
          id={id}
          name={name}
          placeholder={label}
          value={value || ''}
          onChange={onChange}
          maxLength={maxLength}
          minLength={minLength}
          style={inputStyle}
          autoComplete={name === 'oldPassword' ? 'current-password' : 'new-password'}
        />
        <button
          type="button"
          className={showPassword ? 'icon_hide' : 'icon_show'}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          aria-pressed={showPassword}
          style={toggleBtnStyle}
          onMouseDown={toggleVisibility}
        />
      </div>
    </div>
  );
};

export default ProfilePasswordField;
